import { createContext } from 'react'
import { SidebarContextProps } from '@/presentation/common/store/apiContext/types.ts'

export const SidebarContext = createContext<SidebarContextProps>({
  isOpen     : false,
  toggle     : () => void 0,
  forceClose : () => void 0,
})
